import { Appointment } from '~/types/tutoring-api'

import { Ordering } from './Appointments.types'

export function orderAppointments(appointments: Appointment[], ordering: Ordering): Appointment[] {
  if (ordering === 'descending') {
    // eslint-disable-next-line fp/no-mutating-methods
    return [...appointments].sort((a, b) => -a.startTime.localeCompare(b.startTime))
  } else {
    // eslint-disable-next-line fp/no-mutating-methods
    return [...appointments].sort((a, b) => a.startTime.localeCompare(b.startTime))
  }
}
